import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { ChangePasswordComponent } from 'src/app/login/change-password/change-password.component';
import { LoginService } from 'src/app/login/login.service';
import { UserService } from 'src/app/user/user.service';
import { ConfigService } from '../services/config.service';
import { ErrorHandlerService } from '../services/error-handler.service';
import { HeaderService } from './header.service';


declare const toggleSidebar: any;
declare const showResponsiveMenu: any;
declare const addCollapseClass: any;
declare const collapseMenu: any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})


export class HeaderComponent implements OnInit {
  bsModalRef: BsModalRef | any
  public errorMessage: any = null;
  public showLoader: boolean = false;
  public menuList: any = []
  public userPermissionList: any= [];
  rcmRecordPermissionList :any=[];
  workbenchPermissionList:any=[];

  insACQRecordPermissionList:any=[];
  insACQworkbenchPermissionList:any=[];

  insuranceFormRecordPermissionList: any = [];
  insuranceFormworkbenchPermissionList: any = [];

  mceRecordPermissionList: any = [];
  mceworkbenchPermissionList: any = [];

  constructor(public configService: ConfigService,
    private modalService: BsModalService,
    public loginService: LoginService,
    public router: Router,
    private notifier: NotifierService,
    private errorHandler: ErrorHandlerService,
    private userService: UserService,
    public headerService: HeaderService) { }
  public userdata: any
  subscriber: Subscription | undefined;
  ngOnInit(): void {
    
    this.userdata = sessionStorage.getItem("user");
    this.headerService.SetUserData(JSON.parse(this.userdata));
    
    this.subscriber = this.headerService.menuObs$.subscribe(data => this.LocationChanged(data));
    
    this.rcmRecordPermissionList = sessionStorage.getItem("rcmRecordPermissionList");
    this.workbenchPermissionList = sessionStorage.getItem("workbenchPermissionList");


    this.insACQRecordPermissionList = sessionStorage.getItem("insACQRecordPermissionList");
    this.insACQworkbenchPermissionList = sessionStorage.getItem("insACQworkbenchPermissionList");

    this.insuranceFormRecordPermissionList = sessionStorage.getItem("insuranceFormRecordPermissionList");
    this.insuranceFormworkbenchPermissionList = sessionStorage.getItem("insuranceFormworkbenchPermissionList");

    this.mceRecordPermissionList = sessionStorage.getItem("mceRecordPermissionList");
    this.mceworkbenchPermissionList = sessionStorage.getItem("mceworkbenchPermissionList");

  }
  onClick() {
    toggleSidebar();
  }
  collapseResponsiveMenu() {
    showResponsiveMenu()
  }
  addClassActive() {
    collapseMenu();
  }

  add() {
    addCollapseClass();
  }
  ShowChangePasswordBox() {
    let initialState = { title: "Change Password" };
    this.bsModalRef = this.modalService.show(ChangePasswordComponent, { initialState, ignoreBackdropClick: true, keyboard: false, class: 'modal-dialog-centered' });
    this.bsModalRef.content.sendResponse.subscribe();

  }
  Logout() {
    this.showLoader = true;
    this.loginService.Logout().subscribe({
      next: (data: any) => {
        this.add();
        
        sessionStorage.clear();
        localStorage.clear();
        this. RemoveSessionItem();
        this.showLoader = false;
        location.reload();
        this.router.navigateByUrl("/Login");
      }, error: (error: any) => {
        sessionStorage.clear();
        localStorage.clear();
        this.RemoveSessionItem();
        this.router.navigateByUrl("/Login");
      }
    });
  }

  RemoveSessionItem()
  {
    sessionStorage.removeItem("workbenchPermissionList");
    sessionStorage.removeItem("insACQworkbenchPermissionList");
    sessionStorage.removeItem("insuranceFormworkbenchPermissionList");
    sessionStorage.removeItem("mceworkbenchPermissionList");
  }

  LocationChanged(data: any) {
   // if (data) 
    {
      this.rcmRecordPermissionList = sessionStorage.getItem("rcmRecordPermissionList");
      if(this.rcmRecordPermissionList == 0 || !this.rcmRecordPermissionList)
      {
        this.rcmRecordPermissionList = null;
      }

      this.workbenchPermissionList = sessionStorage.getItem("workbenchPermissionList");
      if(this.workbenchPermissionList == 0 || !this.workbenchPermissionList)
      {
        this.workbenchPermissionList = null;
      }

      //insurance ACQ

      this.insACQRecordPermissionList = sessionStorage.getItem("insACQRecordPermissionList");
      if(this.insACQRecordPermissionList == 0 || !this.insACQRecordPermissionList)
      {
        this.insACQRecordPermissionList = null;
      }

      this.insACQworkbenchPermissionList = sessionStorage.getItem("insACQworkbenchPermissionList");
      if(this.insACQworkbenchPermissionList == 0 || !this.insACQworkbenchPermissionList)
      {
        this.insACQworkbenchPermissionList = null;
      }

      //Insurance Form

      this.insuranceFormRecordPermissionList = sessionStorage.getItem("insuranceFormRecordPermissionList");
      if (this.insuranceFormRecordPermissionList == 0 || !this.insuranceFormRecordPermissionList) {
        this.insuranceFormRecordPermissionList = null;
      }

      this.insuranceFormworkbenchPermissionList = sessionStorage.getItem("insuranceFormworkbenchPermissionList");
      if (this.insuranceFormworkbenchPermissionList == 0 || !this.insuranceFormworkbenchPermissionList) {
        this.insuranceFormworkbenchPermissionList = null;
      }

      //MCE

      this.mceRecordPermissionList = sessionStorage.getItem("mceRecordPermissionList");
      if (this.mceRecordPermissionList == 0 || !this.mceRecordPermissionList) {
        this.mceRecordPermissionList = null;
      }

      this.mceworkbenchPermissionList = sessionStorage.getItem("mceworkbenchPermissionList");
      if (this.mceworkbenchPermissionList == 0 || !this.mceworkbenchPermissionList) {
        this.mceworkbenchPermissionList = null;
      }
    }
  }

  GetMenuOptions() {
    this.showLoader = true;
    this.userService.GetMenuOptions().subscribe({
      next: (data: any) => {
        this.menuList = data.Data;
        localStorage.setItem("menuList",this.menuList);
        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("User", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

 
}
